import { render, staticRenderFns } from "./NewRootAddDelivery.vue?vue&type=template&id=1df1669a"
import script from "./NewRootAddDelivery.vue?vue&type=script&lang=js"
export * from "./NewRootAddDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports